<template>
  <div class="voice-form-item">
    <FormItem
      :prop="prop ? `${prop}.text` : ''"
      v-bind="formItemProps"
    >
      <Input
        :disabled="disabled"
        palceholder="请输入话术文本"
        type="textarea"
        :rows="3"
        :value="voice.text"
        @input="uploadText"
        placeholder=""
      />
    </FormItem>
    <FormItem :prop="prop ? `${prop}.voice` : ''" :class="type === 0 ? 'order1' : ''">
      <upload-audio
        @uploadSuccess="uploadFile"
        :filepath="voice.voice"
        @delect="uploadFile('')"
        :disabled="disabled"
      />
    </FormItem>
  </div>
</template>

<script>
import UploadAudio from './uploadAudio.vue'
export default {
  components: { UploadAudio },
  model: {
    prop: 'voice',
    event: 'change'
  },
  props: {
    voice: {
      type: Object,
      default: () => ({
        text: '',
        voice: '',
      })
    },
    prop: {
      type: String,
      default: '',
    },
    formItemProps: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0
    },
  },
  methods: {
    uploadFile(voice) {
      this.$emit('change', { ...this.voice, voice })
    },
    uploadText(text) {
      this.$emit('change', { ...this.voice, text })
    }
  }
}
</script>

<style lang="scss" scoped>
.voice-form-item{
  display: flex;
  flex-direction: column;
  .order1 {
    order: -1;
  }
}
</style>
